import { apiClient } from './client';

// Статусы ответа от бэкенда (patient_context.go)
export type PatientContextStatus = 'ok' | 'no_context' | 'ccs_unavailable';

export interface PatientContextPayload {
  _phone?: string;
  _patient_id?: string;
  _patient_name?: string;
  summary?: string;
  signals?: Array<{ name: string; value: string; severity?: string }>;
  appointments?: Array<{
    date: string;
    doctor: string;
    service: string;
    status: string;
  }>;
  treatment_plan?: string;
  recommendations?: string[];
  [key: string]: unknown;
}

export interface PatientContextResponse {
  status: PatientContextStatus;
  message?: string;
  data?: PatientContextPayload;
}

// Для обратной совместимости — если бэкенд вернул старый формат без status,
// нормализуем к новому конверту.
function normalize(raw: unknown): PatientContextResponse {
  if (raw && typeof raw === 'object' && 'status' in raw) {
    return raw as PatientContextResponse;
  }
  // Старый формат: данные в корне объекта
  return { status: 'ok', data: raw as PatientContextPayload };
}

export async function fetchPatientContext(
  phone: string,
  tenantId: string
): Promise<PatientContextResponse> {
  const { data } = await apiClient.get<unknown>('/api/patient-context', {
    params: { phone },
    headers: { 'X-Tenant-ID': tenantId },
  });
  return normalize(data);
}
